import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const wrap = {
  display: "flex",
  justifyContent: "center",
  width: "100%",
};

const card = {
  width: "100%",
  maxWidth: 1050,
  background: "#f7edff",
  borderRadius: 24,
  padding: 24,
  boxShadow: "0 16px 48px rgba(120, 60, 255, 0.12)",
};

const form = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
};

const textareaStyle = {
  width: "100%",
  height: 140,
  padding: "16px 18px",
  fontSize: 18,
  border: "none",
  borderRadius: 16,
  resize: "none",
  boxShadow: "0 0 0 2px #e5d3ff",
  outline: "none",
  background: "#fff",
};

const buttonRow = {
  display: "flex",
  justifyContent: "flex-end", // ➜ button sits slightly to the right under the textarea
};

const button = (disabled) => ({
  minWidth: 240,
  padding: "14px 24px",
  border: "none",
  borderRadius: 18,
  fontSize: 20,
  fontWeight: 800,
  color: "#2a0060",
  cursor: disabled ? "not-allowed" : "pointer",
  background: "linear-gradient(145deg, #dfc6ff, #cdb3ff)",
  boxShadow:
    "inset 0 2px 0 rgba(255,255,255,0.75), 0 10px 28px rgba(120, 60, 255, 0.25)",
  transition: "transform .18s ease, box-shadow .18s ease",
  opacity: disabled ? 0.7 : 1,
});

export default function FeelingForm() {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const text = message.trim();
    if (!text || sending) return;

    setSending(true);
    try {
      await addDoc(collection(db, "feelings"), {
        message: text,
        timestamp: serverTimestamp(), // stored as Firestore Timestamp
      });
      setMessage(""); // ✅ clear the textarea immediately
    } catch (err) {
      console.error("Failed to post feeling:", err);
    } finally {
      // keep it snappy; if you want longer, raise this to, say, 700ms
      setTimeout(() => setSending(false), 250);
    }
  };

  return (
    <div style={wrap}>
      <div style={card}>
        <form style={form} onSubmit={onSubmit}>
          <textarea
            placeholder="Share your feeling..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={textareaStyle}
            rows={4}
          />
          <div style={buttonRow}>
            <button type="submit" style={button(sending)} disabled={sending}>
              {sending ? "Posting..." : "Post Feeling"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
